export const getAccountUrl = (
  id: number,
  type: "depot" | "account" = "account"
) =>
  `${import.meta.env.VITE_APP_V2_URL}/${
    type === "account" ? "accounts" : "depots"
  }/${id}`;

export const goToAccount = (id: number) =>
  (window.location.href = getAccountUrl(id));
export const goToDepot = (id: number) =>
  (window.location.href = getAccountUrl(id, "depot"));

export const getDashboardUrl = () => `${import.meta.env.VITE_APP_V2_URL}`;
export const goToDashboard = () => (window.location.href = getDashboardUrl());

export const getLegacyDashboardUrl = () =>
  `${import.meta.env.VITE_APP_ROOT_URL}/app`;
export const goToLegacyDashboard = () =>
  (window.location.href = getLegacyDashboardUrl());

export const getSessionLogoutUrl = () =>
  `${import.meta.env.VITE_APP_ROOT_URL}/logoff`;
export const goToSessionLogout = () =>
  (window.location.href = getSessionLogoutUrl());

export const getInvestmentsUrl = () =>
  `${import.meta.env.VITE_APP_V2_URL}/investments`;
export const goToInvestments = () =>
  (window.location.href = getInvestmentsUrl());

export const getInvestmentUrl = (id: number) =>
  `${import.meta.env.VITE_APP_V2_URL}/investments/${id}`;
export const goToInvestment = (
  id?: number,
  qsParams?: { [key: string]: string }
) => {
  const params = new URLSearchParams(qsParams).toString();
  const url = id ? getInvestmentUrl(id) : getInvestmentsUrl();

  if (params) {
    window.location.href = `${url}?${params}`;
  } else {
    window.location.href = url;
  }
};

export const getPremiumUrl = () =>
  `${import.meta.env.VITE_APP_ROOT_URL}/angebote-finanzmanager`;
export const gotToPremium = () => (window.location.href = getPremiumUrl());

export const getCashbackDashboardUrl = () =>
  `${import.meta.env.VITE_APP_V2_URL}/cashback`;
export const goToCashbackDashboard = () =>
  (window.location.href = getCashbackDashboardUrl());

export const getCashbackWizardStart = () =>
  `${import.meta.env.VITE_APP_V2_URL}/cashback-wizard-start`;

export const getCashbackSubscriptionUrl = (id: number) =>
  `${import.meta.env.VITE_APP_V2_URL}/cashback-wizard/${id}/edit`;

export const getV1Url = () => `${import.meta.env.VITE_APP_ROOT_URL}/app`;

export const getSelectBankUrl = () =>
  `${import.meta.env.VITE_APP_V2_URL}/import-bank-connection/select-bank`;
export const goToSelectBank = () => (window.location.href = getSelectBankUrl());

export const getPerformanceUrl = () =>
  `${import.meta.env.VITE_APP_ROOT_URL}/app#!/performance`;
export const goToPerformance = () =>
  (window.location.href = getPerformanceUrl());

export const getEmailConfirmationUrl = () =>
  `${import.meta.env.VITE_APP_V2_URL}/confirmation/email`;
export const goToEmailConfirmation = () =>
  (window.location.href = getEmailConfirmationUrl());

export const getInsurancesUrl = () =>
  `${import.meta.env.VITE_APP_ROOT_URL}/app#!/insurances`;
